import { ChangeDetectionStrategy, Component, effect, viewChild, ViewEncapsulation } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { EmployeeEditWidgetComponent } from '../../hrm/components/employee-edit-widget/employee-edit-widget.component';

@Component({
  selector: 'app-formly-employee-edit',
  templateUrl: './formly-employee-edit.component.html',
  encapsulation: ViewEncapsulation.Emulated,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    EmployeeEditWidgetComponent
  ]
})
export class FormlyEmployeeEditComponent extends FieldType<FieldTypeConfig> {
  private readonly employeeWidget = viewChild(EmployeeEditWidgetComponent);
  private employeeWasDirty = false;

  constructor() {
    super();
    effect(() => {
      const widget = this.employeeWidget();
      const employeeDirty = !!widget?.modelIsDirtySig();
      const employeeControl = this.form?.get('employee');
      if (!employeeControl) {
        return;
      }

      if (employeeDirty) {
        employeeControl.markAsDirty();
        this.options?.formState?.detailComponent?.modelIsDirtySig.set(true);
        this.employeeWasDirty = true;
        return;
      }

      if (this.employeeWasDirty) {
        employeeControl.markAsPristine();
        this.options?.formState?.detailComponent?.notifyDirtyRecheck();
        this.employeeWasDirty = false;
      }
    });
  }

  employeeModelId(): string | null {
    const employeeId = (this.props as { employeeId?: string }).employeeId;
    return employeeId || null;
  }

  onEmployeeChange(value: FormGroup) {
    this.form.get('employee')?.patchValue(value, { emitEvent: false });
  }
}
